import React from "react";

import styles from "./Boost.module.scss";
import ImageText from "./Elements/ImageText";

import boost1src from "../images/boost-01.jpg";
import boost1srcRet from "../images/boost-01@2x.jpg";
import boost1webp from "../images/boost-01.webp";
import boost1webpRet from "../images/boost-01@2x.webp";


import boost2src from "../images/boost-02.jpg";
import boost2srcRet from "../images/boost-02@2x.jpg";
import boost2webp from "../images/boost-02.webp";
import boost2webpRet from "../images/boost-02@2x.webp";

import TitleBloc from "./Elements/TitleBloc";
import Quote from "./Elements/Quote";
import Chart3 from "./Chart3";

import backgroundSrc from "../images/background-04.jpg";
import backgroundSrcRet from "../images/background-04@2x.jpg";
import backgroundWebp from "../images/background-04.webp";
import backgroundWebpRet from "../images/background-04@2x.webp";
import backgroundMobile from "../images/mobile/background-04.webp";

export default function Boost() {
    return (
        <section className={styles.Main}>
            <div className="container">
                <ImageText classname={'sticky--image'} image={{
                    src: boost1src, srcRet: boost1srcRet, webp: boost1webp, webpRet: boost1webpRet
                }}>
                    <p>
                        L’une des recommandations de l’Organisation mondiale de la Santé (OMS) pour gérer les situations de confinement et de quarantaine était d’ailleurs de jouer aux jeux vidéo. Cette recommandation faisait partie de l’initiative #PlayApartTogether, créée par des développeurs de jeux vidéo tels qu’Activision-Blizzard et Zynga. L’objectif de cette initiative est de promouvoir l’interaction sociale par le biais des jeux en ligne et, ainsi, de favoriser la distanciation sociale et d’aider à ralentir la propagation du virus. Alors que les périodes de confinement ont pu engendrer de l’isolement social, l’émergence de nouvelles plateformes de jeu a incité les entreprises de jeux vidéo à se concentrer un peu plus sur l’expérience et les « relations sociales ». Si elles ont permis aux gens de se divertir pendant la pandémie, les plateformes proposent effet aux joueurs des interactions sociales. Cette adaptation était nécessaire pour les entreprises du secteur pour qu’elles restent pertinentes, que ce soit dans ce contexte de crise sanitaire, ou pour l’avenir…
                    </p>
                </ImageText>

                <Quote source={"Phil Spencer,<br/> dirigeant de Xbox Game Studios à ‘Business Insider US’"} text={"Le jeu est un lien social et communautaire pour beaucoup de gens, et comme la distanciation sociale exige que les gens soient physiquement séparés, les liens sociaux et communautaires que l'industrie du jeu apporte aux gens ne font que s'élargir"}/>

                <ImageText classname={'sticky--image'} image={{
                    src: boost2src, srcRet: boost2srcRet, webp: boost2webp, webpRet: boost2webpRet
                }}>
                    <p>
                        En 2020, les ventes de jeux vidéo aux Etats-Unis ont atteint un record, s'élevant à 56,9 milliards de dollars, selon un rapport du cabinet d'études NPD Group. En France également, le secteur a réalisé sa meilleure performance avec une croissance de plus de 11,3% l’an dernier. Les ventes de consoles ont augmenté de 11% dans l’Hexagone, sous l’effet notamment du succès de la Switch de Nintendo. Le marché touche 2,7 milliards de joueurs sur la planète, soit une progression de 500 millions d’utilisateurs au cours des trois dernières années. Les projections tablent sur 400 millions de joueurs de plus d’ici à fin 2023 pour atteindre 3 milliards de joueurs…
                    </p>
                </ImageText>

                <p className={[styles.GraphTitle, 'head-text', 'aside'].join(' ')}>
                    <strong>Nombre total de joueurs</strong> <br/>
                    dans le monde de 2015 à 2023
                </p>


                <Chart3/>

                <p className={styles.ChartSources}>
                    « Global Games Market Report », Newzoo, 2020
                </p>
            </div>

            <TitleBloc number={4} image={{
                src: backgroundSrc,
                srcRet: backgroundSrcRet,
                webp: backgroundWebp,
                webpRet: backgroundWebpRet,
                mobile: backgroundMobile
            }}>
                <h2>
                    Un aspect social <br/>
                    prédominant ?
                </h2>

                <p>
                    Alors que les joueurs se font de plus en plus nombreux, les profils se diversifient. Si le marché était initialement orienté vers les adolescents, il s’est par la suite développé pour inclure les jeunes adultes. Les femmes sont également montées en puissance et représentent aujourd'hui près de la moitié des joueurs de jeux vidéo.
                </p>
            </TitleBloc>
        </section>
    )
}
